

<template>
<ROOT></ROOT>
</template>

<script>
import ROOT from "@/component/ROOT";

export default {
  data() {
    return {};
  },


  
  mounted() {
    document.body.style.height = document.documentElement.clientHeight+"px";
  },

  methods: {

  },

  components: {
    ROOT
  }
};
</script>

<style lang="scss">
@import "D:/workspace/all_web/src/_cmm/css/centerbg.scss";
@import "./d.scss";

body {
  margin: 0;
  width: 100vw;
  height: 100vh;
  // overflow: hidden;
}

.fullcontainer {
  width: 100vw;
  height: 100%;
  // overflow: hidden;
}

img,video,canvas{
  position: absolute;
}

.centerbg {
  @include centerbg;
}

.iconsize {
  width: 12%;
}

.mask {
  background-color: black;
  opacity: 0.6;
  width: 100%;
  height: 100%;
}

</style>
